<h2 class="filter-hd">Filters</h2>
<!-- <div class="side-filter-wrap" *ngIf="PageName!= '/superVerifier'"> -->
  <!-- <div class="side-filter-wrap" >
  <p class="filter-subhd">
    <a class="btn-filter" data-toggle="collapse" href="#records" role="button" aria-expanded="false" aria-controls="collapseExample">
      <span class="filter-subhd-txt">Show Records</span>
      <span class="filter-subhd-icon"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
    </a>
  </p>
  <div class="collapse show" id="records" >
    <div class="card card-body">
      <ul class="side-filter-ul">
          <li><a (click)="clickHandlerAll()"  class={{sideactiveAll}}>All</a></li>
          <li><a  (click)="clickHandlerOpen()"  class={{sideactiveOpen}}>Open</a></li>
          <li><a (click)="clickHandlerClosed()"  class={{sideactiveClosed}}>Closed</a></li>
      </ul>
    </div>
  </div> 
</div>-->
<div class="side-filter-wrap mt-4">
    <p class="filter-subhd">
      <a class="btn-filter" data-toggle="collapse" href="#date-range" role="button" aria-expanded="false" aria-controls="collapseExample">
        <span class="filter-subhd-txt">Date Range</span>
        <span class="filter-subhd-icon"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
      </a>
    </p>
    <div class="collapse show" id="date-range">
      <div class="card card-body">
        <ul class="side-filter-ul">
            <li><span class="side-filter-label">From</span> <input type="date" (change)="fromDate()" [max]="getToday()" [(ngModel)]="fromDatee"   class="side-filter-input"></li>
            <li><span class="side-filter-label">Till</span> <input type="date" (change)="toDate()" [max]="getToday()"  [(ngModel)]="toDatee" class="side-filter-input"></li>
        </ul>
      </div>
    </div>
  </div>
  
